const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Inicio",
    icon: "home",
    url: "/dashboard",
    issubMenubadge: true,
  },
  {
    label: "Resumen Diario",
    icon: "description",
    url: "/resumeDay",
    issubMenubadge: true,
    module: "resumeDay",
  },
  {
    label: "Estadisticas",
    icon: "bar_chart",
    url: "/stats",
    issubMenubadge: true,
  },
    {
    label: "Caja",
    icon: "attach_money",
    url: "/cash",
    issubMenubadge: true,
  },
  {
    label: "Tickets",
    icon: "confirmation_number",
    url: "/tickets",
    issubMenubadge: true,
  },
  {
    label: "Capturas",
    icon: "videocam",
    url: "/anpr",
    module: "anpr",
    issubMenubadge: true,
  },
  {
    label: "Entradas/Salidas",
    icon: "swap_horiz",
    url: "/inout",
    module: "inout",
    issubMenubadge: true,
  },
  {
    label: "Mensuales",
    labelV2: "Abonados", // cliente con app >= 2.0 usa terminología nueva
    icon: "event_available",
    url: "/cc",
    issubMenubadge: true,
  },
  {
    // Sección Gestión: configuraciones avanzadas que el dueño controla
    // remotamente sobre la máquina del estacionamiento.
    // Gateado por `requiresTariffs`: el doc `tariffs` solo lo genera tc_qml
    // 2.0.20+ (que además es la versión que introduce los handlers de socket
    // update_tariffs y update_oper_permissions). Si hay tariffs, el cliente
    // soporta ambos flujos remotos.
    label: "Gestión",
    icon: "settings",
    requiresTariffs: true,
    pill: { text: "Nuevo", color: "success" },
    subItem: [
      {
        // Tarifario se muestra a todos: tiene valor consultar precios
        // configurados aunque no se puedan editar.
        sublabel: "Tarifario",
        link: "/tarifario",
        requiresTariffs: true,
      },
      {
        // Permisos de Operadores: config interna sin valor para quien no
        // administra. Solo visible con permiso de Gestión.
        sublabel: "Permisos de Operadores",
        link: "/permisos-operadores",
        requiresAppConfig: true,
        requiresEditPermission: true,
      },
      {
        // Informes: destinatarios y frecuencias son config interna.
        // Solo visible con permiso de Gestión.
        sublabel: "Informes",
        link: "/informes",
        requiresAppConfig: true,
        requiresEditPermission: true,
      },
      {
        // Accesos a Monitor: expone quién tiene acceso → sensible.
        // Solo visible con permiso de Gestión.
        sublabel: "Accesos a Monitor",
        link: "/accesos",
        requiresEditPermission: true,
      },
    ],
  },
  {
    label: "Sesiones",
    icon: "group",
    url: "/sessions",
    issubMenubadge: true,
  },
  {
    label: "Backups",
    icon: "storage",
    url: "/backups",
    issubMenubadge: true,
  },
  {
    label: "Estacionamientos",
    icon: "local_parking",
    url: "/companiesOptions",
    issubMenubadge: true,
  },
];
export default SidebarData;
